'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import arrowStyles from '@/app/lcv/components/sections/spartan/shared/arrow-motion.module.css';
import { SPARTAN_SLIDER_NAV_BUTTON_CLASS_NAME, SPARTAN_SLIDER_NAV_LABELS, SPARTAN_SLIDER_NAV_WHITE_DISABLED_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/shared/slider-nav/constants';
import { SPARTAN_SLIDER_NAV_TRACKING } from '@/app/lcv/components/sections/spartan/shared/slider-nav/tracking';
import type { SpartanSliderNavProps } from '@/app/lcv/components/sections/spartan/shared/slider-nav/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export { SPARTAN_SLIDER_NAV_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/shared/slider-nav/constants';
export const SpartanSliderNav = t0 => {
  const $ = _c(59);
  const {
    testId: t1,
    prevTestId: t2,
    nextTestId: t3,
    onPrev,
    onNext,
    isPrevDisabled: t4,
    isNextDisabled: t5,
    className,
    buttonClassName: t6,
    color: t7,
    tracking
  } = t0;
  const testId = t1 === undefined ? SPARTAN_SLIDER_NAV_TRACKING.root : t1;
  const prevTestId = t2 === undefined ? SPARTAN_SLIDER_NAV_TRACKING.prev : t2;
  const nextTestId = t3 === undefined ? SPARTAN_SLIDER_NAV_TRACKING.next : t3;
  const isPrevDisabled = t4 === undefined ? false : t4;
  const isNextDisabled = t5 === undefined ? false : t5;
  const buttonClassName = t6 === undefined ? SPARTAN_SLIDER_NAV_BUTTON_CLASS_NAME : t6;
  const color = t7 === undefined ? "black" : t7;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t8;
  let t9;
  if ($[0] !== buttonClassName || $[1] !== className || $[2] !== color || $[3] !== isNextDisabled || $[4] !== isPrevDisabled || $[5] !== onNext || $[6] !== onPrev || $[7] !== prevTestId || $[8] !== testId || $[9] !== tracking) {
    const resolvedButtonClassName = cn(buttonClassName, color === "white" && SPARTAN_SLIDER_NAV_WHITE_DISABLED_BUTTON_CLASS_NAME);
    t17 = "group";
    t18 = SPARTAN_SLIDER_NAV_LABELS.ariaLabel;
    if ($[25] !== className) {
      t19 = cn("flex items-center gap-4", className);
      $[25] = className;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    if ($[27] !== testId) {
      t20 = createDataAttributes({
        test: testId
      });
      $[27] = testId;
      $[28] = t20;
    } else {
      t20 = $[28];
    }
    let t22;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <span className={cn("block size-full", arrowStyles.arrowLeft)}><IconArrowBack /></span>;
      $[29] = t22;
    } else {
      t22 = $[29];
    }
    const t23 = cn(resolvedButtonClassName, arrowStyles.trigger);
    let t24;
    if ($[30] !== prevTestId) {
      t24 = createDataAttributes({
        test: prevTestId
      });
      $[30] = prevTestId;
      $[31] = t24;
    } else {
      t24 = $[31];
    }
    let t25;
    if ($[32] !== tracking) {
      t25 = tracking ? createDataGA({
        ...tracking,
        click: true,
        text: SPARTAN_SLIDER_NAV_LABELS.prev,
        value: "prev"
      }) : {};
      $[32] = tracking;
      $[33] = t25;
    } else {
      t25 = $[33];
    }
    t21 = <Button type="button" aria-label={SPARTAN_SLIDER_NAV_LABELS.prev} variant="primary" color={color} size="sm" iconBefore={t22} disabled={isPrevDisabled} onClick={onPrev} className={t23} {...t24} {...t25} />;
    T0 = Button;
    t8 = "button";
    t9 = SPARTAN_SLIDER_NAV_LABELS.next;
    t10 = "primary";
    t11 = color;
    t12 = "sm";
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <span className={cn("block size-full", arrowStyles.arrow)}><IconArrowForward /></span>;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    t14 = isNextDisabled;
    t15 = onNext;
    t16 = cn(resolvedButtonClassName, arrowStyles.trigger);
    $[0] = buttonClassName;
    $[1] = className;
    $[2] = color;
    $[3] = isNextDisabled;
    $[4] = isPrevDisabled;
    $[5] = onNext;
    $[6] = onPrev;
    $[7] = prevTestId;
    $[8] = testId;
    $[9] = tracking;
    $[10] = T0;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
    $[17] = t16;
    $[18] = t17;
    $[19] = t18;
    $[20] = t19;
    $[21] = t20;
    $[22] = t21;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[10];
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
    t16 = $[17];
    t17 = $[18];
    t18 = $[19];
    t19 = $[20];
    t20 = $[21];
    t21 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t22;
  if ($[35] !== nextTestId) {
    t22 = createDataAttributes({
      test: nextTestId
    });
    $[35] = nextTestId;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== tracking) {
    t23 = tracking ? createDataGA({
      ...tracking,
      click: true,
      text: SPARTAN_SLIDER_NAV_LABELS.next,
      value: "next"
    }) : {};
    $[37] = tracking;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== T0 || $[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t22 || $[48] !== t23 || $[49] !== t8 || $[50] !== t9) {
    t24 = <T0 type={t8} aria-label={t9} variant={t10} color={t11} size={t12} iconBefore={t13} disabled={t14} onClick={t15} className={t16} {...t22} {...t23} />;
    $[39] = T0;
    $[40] = t10;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = t22;
    $[48] = t23;
    $[49] = t8;
    $[50] = t9;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t17 || $[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t21 || $[57] !== t24) {
    t25 = <div role={t17} aria-label={t18} className={t19} {...t20}>{t21}{t24}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
    $[56] = t21;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  return t25;
};